import { csx, Grid, Text } from '@vtex/admin-ui'
import React from 'react'
import type { DefaultProps } from 'typings'

interface Props extends DefaultProps {
  className?: string
}

export function Title(props: Props) {
  return (
    <Text
      tone="secondary"
      className={csx({ order: 0, marginRight: '$space-2' })}
    >
      {props.children}
    </Text>
  )
}

export function Value(props: Props) {
  return (
    <div
      className={`${csx({
        order: 1,
        ':empty': { '~ *': { display: 'none' } },
      })} ${props.className ?? ''}`}
    >
      {props.children}
    </div>
  )
}

export function SummaryRow(props: Props) {
  return (
    <Grid
      templateColumns="minmax(0, 1fr) minmax(0, 2fr)"
      className={csx({
        ':has(:empty):not(:has(svg *))': { display: 'none' },
      })}
    >
      {React.Children.toArray(props.children).reverse()}
    </Grid>
  )
}

SummaryRow.Title = Title
SummaryRow.Value = Value
